const state = {
	isLoading: false,
	isAuthenticated: Boolean(localStorage.getItem("auth_token")),
	error: null,
	user: {}
};

export default state;
